// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1LL-e","insightsList":"newBusinessInsightsMenu_insightsList__B6eEu","active":"newBusinessInsightsMenu_active__1o_yb"};